// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import langs from './langs'
import VueCookie from 'vue-cookie'
import { store } from './store'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Vuelidate from 'vuelidate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import $ from 'jquery'
import moment from 'moment'
import './utils/filters'

import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.min.css";

Vue.use(FullCalendar);
Vue.use(VueCookie);
Vue.use(BootstrapVue);
Vue.use(VueI18n);
Vue.use(VueFormWizard);
Vue.use(Vuelidate);

Vue.use(VueAxios, axios);
Vue.axios.defaults.headers.common['Authorization'] =VueCookie.get('token');

Vue.use(VueQuillEditor);

// import from langs file 
const messages = langs.translate;

// get current locale preference
Vue.config.lang = VueCookie.get('locale') || 'en_us'
console.log("Locale from cookie = " + Vue.config.lang)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: Vue.config.lang, // set locale
  messages, // set locale messages
})
require('./assets/main.css')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js